module.exports = __webpack_public_path__ + "img/grade-U.bbb8bd66.svg";